<template>
  <div>
    <card>
        <div v-if="openid !== ''" style="width:100%">
          <Button type="info" @click="ReturnHandleClick">返回</Button>
        </div>
        <RadioGroup v-model="condition" type="button" v-if="openid === ''">
          <Radio label="全部"></Radio>
          <Radio label="姓名"></Radio>
          <Radio label="公司"></Radio>
          <Radio label="手机"></Radio>
          <Radio label="认证手机号"></Radio>
          <Radio label="地区"></Radio>
          <Radio label="客户名称"></Radio>
          <Radio label="销售员" v-if="SalespersonID === ''"></Radio>
        </RadioGroup>
        <Input v-model="value" placeholder="请选择左边内容后输入你需要查询的内容..." style="margin:0 .2rem 0 .5rem;width: 300px" v-if="openid === ''"/>
        <Button type="primary" @click="QueryHandleClick" v-if="openid === ''">查询</Button>
        <List item-layout="vertical">
        <ListItem v-for="(item, index) in lists" :key="item.openid">
            <Avatar style="background-color: #87d068" icon="ios-person" />
            <ListItemMeta v-if="item.Isedit === false"  :title="item.UserName"/>
            <div v-else>姓名：<Input v-model="Fromdata.UserName" placeholder="请输入用户姓名..." style="width: 300px" /></div>

            <div v-if="item.Isedit === false">{{ item.Company_Name }}</div>
            <div v-else>公司名称：<Input v-model="Fromdata.Company_Name" placeholder="请输入公司名称..." style="width: 300px" /></div>

            <div>
              <div v-if="item.Isedit === false">客户编号：{{ item.Customer_No }}</div>
              <div v-else>客户编号：<Input v-model="Fromdata.Customer_No" placeholder="请输入客户编号..." style="width: 300px" /></div>
            </div>

            <div>
              <div v-if="item.Isedit === false">客户名称：{{ item.Customer_Name }}</div>
              <div v-else>客户名称：<Input v-model="Fromdata.Customer_Name" placeholder="请输入客户名称..." style="width: 300px" /></div>
            </div>

            <div>
              <div v-if="item.Isedit === false">备注：{{ item.Remarks }}</div>
              <div v-else>备注：<Input v-model="Fromdata.Remarks" placeholder="请输入备注..." style="width: 300px" /></div>
            </div>
            <template slot="action">
                <li>
                    <div v-if="item.Isedit === false">手机：{{ item.Mobile_Phone }}</div>
                    <div v-else>手机：<Input v-model="Fromdata.Mobile_Phone" placeholder="请输入手机..." style="width: 300px" /></div>
                </li>
                <li>
                    认证手机号:{{item.PhoneNumber}}
                </li>
            </template>
            <template slot="action">
                <li>
                    <div v-if="item.Isedit === false">地区：{{item.Region}}</div>
                    <div v-else>地区：<Input v-model="Fromdata.Region" placeholder="请输入地区..." style="width: 300px" /></div>
                </li>
                <li>
                    认证时间:{{item.Verification_Time}}
                </li>
            </template>
            <template slot="action">
                <li v-if=" item.Verification_state == '1' " style="color: #52c41a;background: #f6ffed;border: 1px solid #b7eb8f">已认证</li>
                <li v-else style="color: #f5222d;background: #fff1f0;border: 1px solid #ffa39e">未认证</li>
                <li>
                    <div v-if="item.Isedit === false">销售员:{{item.SalespersonName}}</div>
                    <div v-if="item.Isedit === true && SalespersonID === ''">
                      <!-- 销售员:<Input v-model="Fromdata.SalespersonName" placeholder="请输入销售员..." style="width: 300px" /> -->
                      销售员:
                      <Select v-model="Fromdata.SalespersonID"
                      value="Fromdata.SalespersonName"
                      :label-in-value="true"
                      @on-change="SalespersonHandleClick"
                      clearable
                      filterable
                      style="width: 300px">
                        <Option :value="item1.UserID" v-for="item1 of SalespersonList" :key="item1.UserID">{{item1.UserName}}</Option>
                      </Select>
                    </div>
                </li>
            </template>
            <template slot="extra" v-if="item.Verification_state == '1'">
                <Button type="primary" ghost v-if="!item.Isedit" @click="EditHandleClick(index)">编辑</Button>
                <Button type="info" v-if="item.Isedit" @click="SaveHandleClick(index)">保存</Button>
            </template>
            <!-- Verification_state -->
        </ListItem>
       </List>
       <Page :total="total" show-sizer show-elevator @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
       <Spin size="large" fix v-if="SpinShow"></Spin>
    </card>
  </div>
</template>

<script>
import { CustomerList, GetSalespersonListApi, ChangeCustomerList, CustomerList1 } from './../../../api/Customer'
export default {
  name: 'CustomerList',
  data () {
    return {
      lists: [],
      SpinShow: false,
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      condition: '全部',
      value: '',
      SalespersonID: '',
      Fromdata: {
        openid: '',
        UserName: '',
        Company_Name: '',
        Mobile_Phone: '',
        PhoneNumber: '',
        Region: '',
        SalespersonName: '',
        SalespersonID: '',
        Customer_Name: '',
        Customer_No: '',
        Remarks: ''
      },
      SalespersonList: [],
      Isedit: false,
      openid: ''
    }
  },
  mounted: function () {
    if (this.$store.state.userInfo.roleName === '销售员') {
      this.SalespersonID = this.$store.state.userInfo.userID
    } else {
      if (this.$route.query.openid) {
        this.openid = this.$route.query.openid
        this.GetCustomerList1()
      } else {
        this.GetCustomerList()
      }
    }
    this.GetSalespersonList()
  },
  methods: {
    GetCustomerList () {
      this.SpinShow = true
      CustomerList(this.CurrentPage, this.pageSize, this.condition, this.value, this.SalespersonID).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.total
          this.lists = res.Data.CustomerData
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 根据openid获取客户数据
    GetCustomerList1 () {
      this.SpinShow = true
      CustomerList1(this.openid).then(res => {
        if (res.IsSuccess) {
          this.lists = res.Data.CustomerData
          this.SpinShow = false
        } else {
          this.$Message.error(res.Message)
          this.SpinShow = false
        }
      })
    },
    // 获取销售人员数据
    GetSalespersonList () {
      GetSalespersonListApi().then(res => {
        if (res.IsSuccess) {
          this.SalespersonList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页码
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetCustomerList()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetCustomerList()
      }
    },
    // 点击编辑按钮回调
    EditHandleClick (index) {
      if (this.Isedit) {
        this.$Modal.warning({
          title: '操作失败',
          content: '先保存正在操作的内容，再编辑下一个。'
        })
      } else {
        this.Fromdata = {
          openid: this.lists[index].openid,
          UserName: this.lists[index].UserName,
          Company_Name: this.lists[index].Company_Name,
          Mobile_Phone: this.lists[index].Mobile_Phone,
          PhoneNumber: this.lists[index].PhoneNumber,
          Region: this.lists[index].Region,
          SalespersonName: this.lists[index].SalespersonName,
          SalespersonID: this.lists[index].SalespersonID,
          Remarks: this.lists[index].Remarks,
          Customer_Name: this.lists[index].Customer_Name,
          Customer_No: this.lists[index].Customer_No
        }
        this.Isedit = true
        this.lists[index].Isedit = true
      }
    },
    // 点击保存按钮回调
    SaveHandleClick (index) {
      this.SpinShow = true
      ChangeCustomerList({
        openid: this.Fromdata.openid,
        UserName: this.Fromdata.UserName,
        Company_Name: this.Fromdata.Company_Name,
        Remarks: this.Fromdata.Remarks,
        Mobile_Phone: this.Fromdata.Mobile_Phone,
        Region: this.Fromdata.Region,
        SalespersonID: this.Fromdata.SalespersonID,
        Customer_Name: this.Fromdata.Customer_Name,
        Customer_No: this.Fromdata.Customer_No
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          if (this.openid === '') {
            this.GetCustomerList()
          } else {
            this.GetCustomerList1()
          }
          this.Isedit = false
        } else {
          this.$Message.error(res.Message)
          this.Isedit = false
        }
      })
    },
    // 点击查询按钮回调
    QueryHandleClick () {
      this.GetCustomerList()
    },
    // 销售人员选择后回调
    SalespersonHandleClick (value) {
      this.Fromdata.SalespersonID = value.value
      this.Fromdata.SalespersonName = value.label
    },
    // 点击返回按钮回调
    ReturnHandleClick () {
      this.$router.push({ name: 'Home_AppletOrder' })
    }
  }
}
</script>
